import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { formatPlanning } from '@util/bijlage-template-util'
import { formatDateTime } from '@util/date-util'

import type { ActiviteitTemplate as ActiviteitTemplateType } from '../types/ActiviteitTemplate'
import { formatAssignedTo } from '../util'

import { TemplateOption } from './TemplateOption'

interface Props {
  activiteitTemplate: ActiviteitTemplateType
}

export const ActiviteitTemplate = ({ activiteitTemplate }: Props) => {
  const {
    type,
    reference,
    herplanDiff,
    assignedTo,
    ingangsdatum,
    skipSoloKcm1,
    projectType,
    displayOnly,
  } = activiteitTemplate

  const formatIngangsdatum = (date?: string | Date) => {
    if (!date) return '-'
    return formatDateTime(date).split(' ')[0] // Get only the date part
  }

  const formatSkipSoloKcm1 = (skip?: string[] | null) => {
    if (!skip || skip.length === 0) return '-'
    return skip.join(', ')
  }

  return (
    <TableRow hover>
      <TableCell>{type}</TableCell>

      <TableCell>
        {formatPlanning(herplanDiff, reference)}
        <br />
        {projectType === 'Hoofdleiding' && !displayOnly && (
          <Typography variant="caption">
            Wacht op overgang naar werkvoorbereiding
          </Typography>
        )}
      </TableCell>

      <TableCell>{formatAssignedTo(assignedTo)}</TableCell>
      <TableCell>
        <TemplateOption
          label="Automatisch"
          option={!displayOnly}
          tooltip={
            displayOnly
              ? 'Activiteit kan alleen handmatig op het project worden geplaatst'
              : 'Activiteit wordt automatisch op het project geplaatst'
          }
        />
      </TableCell>

      {projectType === 'Aanvraag' && (
        <>
          <TableCell>{formatIngangsdatum(ingangsdatum)}</TableCell>
          <TableCell>{formatSkipSoloKcm1(skipSoloKcm1)}</TableCell>
        </>
      )}
    </TableRow>
  )
}
